__turbopack_context__.v({
  "buttonContainer": "index-module__H97mPa__buttonContainer",
  "closeIcon": "index-module__H97mPa__closeIcon",
  "content": "index-module__H97mPa__content",
  "modalContent": "index-module__H97mPa__modalContent",
  "okButton": "index-module__H97mPa__okButton",
  "text": "index-module__H97mPa__text",
});
